import React from 'react'
import { Menu, MenuItem } from '@mui/material'
import { useHasPermission } from 'app-support/permissions/RequiredPermissions'
import {
  PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU,
  PERMISSION_RESET_USER_PROFILE_HAMBURGER_MENU
} from 'app-support/permissions/Permissions'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'

interface Props {
  open: boolean
  handleClose: () => void
  handleReimportConcepts?: () => void
  navigateToDetails: () => void
  navigateToConcepts: () => void
  position: { screenY: number; screenX: number }
  onResetActivation: () => void
  onResetUser?: () => void
}

const useStyles = makeStyles({
  paper: {
    borderRadius: 0,
    zIndex: 1000,
    padding: '0px',
    margin: '0px'
  },
  menuItem: {
    borderBottom: '1px solid #f2f3f5'
  }
})

const CustomMenu: React.FC<Props> = ({
  open,
  handleClose,
  handleReimportConcepts,
  navigateToDetails,
  position,
  navigateToConcepts,
  onResetActivation,
  onResetUser
}) => {
  const [hasPermission] = useHasPermission(PERMISSION_EDIT_CUSTOMER_PROFILE_HAMBURGER_MENU)
  const [hasResetUserPermission] = useHasPermission(PERMISSION_RESET_USER_PROFILE_HAMBURGER_MENU)
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Menu
      open={Boolean(open)}
      onClose={handleClose}
      anchorReference='anchorPosition'
      anchorPosition={{ top: position.screenY ?? 0, left: position.screenX ?? 0 }}
      classes={{ paper: classes.paper }}
    >
      <MenuItem disabled={!hasPermission} onClick={navigateToDetails} className={classes.menuItem}>
        {t('CustomMenu.Details')}
      </MenuItem>
      <MenuItem disabled={!hasPermission} onClick={handleReimportConcepts} className={classes.menuItem}>
        {t('CustomMenu.ReimportFromEOS')}
      </MenuItem>
      <MenuItem disabled={!hasPermission} onClick={onResetActivation} className={classes.menuItem}>
        {t('CustomMenu.ResetActivationCode')}
      </MenuItem>
      {onResetUser && (
        <MenuItem disabled={!hasResetUserPermission} onClick={onResetUser} className={classes.menuItem}>
          {t('CustomMenu.ResetCustomer')}
        </MenuItem>
      )}
      <MenuItem disabled={!hasPermission} onClick={navigateToConcepts} className={classes.menuItem}>
        {t('CustomMenu.EditingConcepts')}
      </MenuItem>
    </Menu>
  )
}

export default CustomMenu
